"use client";
import { useState } from "react";
import Link from "next/link";

export function IntroBannerSection() {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-[65] w-full bg-blue-700 flex items-center justify-center min-h-[44px] py-2 lg:py-0 lg:h-11">
      <div className="flex items-center gap-1 lg:gap-2.5 px-4 lg:px-0 max-w-full">
        <div className="text-white/80 text-sm lg:text-base font-medium font-['Pretendard'] text-center leading-tight lg:leading-normal">
          <span className="hidden lg:inline">아이뱅크 디지털웍스(DW) AI의 전문적 큐레이션 리포팅서비스를 소개해드릴게요</span>
          <span className="lg:hidden">DW AI 큐레이션 서비스 소개</span>
        </div>
        <Link 
          href="/about" 
          className="text-white text-sm lg:text-base font-semibold font-['Pretendard'] underline hover:opacity-80 transition-opacity whitespace-nowrap flex-shrink-0"
        >
          보러 가기
        </Link>
      </div>
      <button
        onClick={handleClose}
        className="absolute right-2 lg:right-4 top-1/2 -translate-y-1/2 w-5 h-5 lg:w-6 lg:h-6 flex items-center justify-center hover:opacity-80 transition-opacity flex-shrink-0"
        aria-label="배너 닫기"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="lg:w-6 lg:h-6">
          <path 
            d="M17.6564 17.6536L6.3427 6.33992" 
            stroke="white" 
            strokeWidth="1.2" 
            strokeLinecap="round"
          />
          <path 
            d="M17.6573 6.33992L6.34359 17.6536" 
            stroke="white" 
            strokeWidth="1.2" 
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
